import { Box, Button } from '@mui/material';
import { FunctionComponent } from 'react';
import { useAppTranslate } from '../../../core/hooks';
import { Loader } from '../../../ui/components';
import { useL3ServiceDetailsApiGet } from '../../hooks/L3ServiceLocationDetailsApiGet/L3ServiceLocationDetailsApiGet.hook';
import { L3ServiceStatusBadge } from '../L3ServiceStatusBadge/L3ServiceStatusBadge';
import { TopologyOverlayLeftColumnView } from '../Topology/Topology';

interface Props {
  itemId: number;
  customerId: number;
  leftColumnView: TopologyOverlayLeftColumnView;
  onEditPositionClicked: () => void;
}

export const TopologyMarkerDetailsPopup: FunctionComponent<Props> = ({
  customerId,
  itemId,
  leftColumnView,
  onEditPositionClicked,
}) => {
  const translate = useAppTranslate();
  const { l3Service, isFetching, isFetched } = useL3ServiceDetailsApiGet(customerId, itemId);

  return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '320px' }}>
    { isFetching
    ? <Loader loading={true} />
    : ((isFetched && !isFetching && l3Service)
      ? <Box>
        <Box>{ translate('markerPopup.soz') }: { l3Service.orderNumber }</Box>
        <Box>
          <Box>{ translate('markerPopup.location') }: { l3Service.address }</Box>
        </Box>
        <Box sx={{ display: 'inline'}}>{ translate('markerPopup.serviceName') }: <Box sx={{ display: 'inline-block', fontWeight: 900 }}>{ l3Service.name }</Box></Box>
        <L3ServiceStatusBadge l3Service={ l3Service } />
        { l3Service.formattedMaintenanceWorks !== undefined
          && <Box>{ translate('markerPopup.maintenanceWorks') }: { l3Service.formattedMaintenanceWorks }</Box>
        }
        { leftColumnView === TopologyOverlayLeftColumnView.None
          && <Button sx={{ marginTop: '8px' }} variant='contained' onClick={ onEditPositionClicked }>{ translate('markerPopup.editPosition') }</Button>
        }
      </Box>
      : null)
    }
  </Box>;
};